/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Org_Contract_Badge_DormantInputs */



/**
* | output |
* | --- |
* | "Contract starts {date}" |
*
* @param {Partner_Org_Contract_Badge_DormantInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_badge_dormant = /** @type {((inputs: Partner_Org_Contract_Badge_DormantInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Badge_DormantInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Vertrag beginnt ${i?.date}`)
	return /** @type {LocalizedString} */ (`Contract starts ${i?.date}`)
});